import React from 'react';
import postData from "../service/fetcher";

export default class Folder extends React.Component {

    constructor(props) {
        super(props);
        this.input = this.input.bind(this);
        this.deleteFolder = this.deleteFolder.bind(this);
    }

    delete(id) {
        if (window.confirm('Are you sure you wish to delete this item?')) {
            postData("/api/Delete", {token: this.props.token}, {id: id})[0].then(() => {
                document.getElementById(id).remove();
            });
        }
    }

    deleteFolder() {
        if (window.confirm('Are you sure you wish to delete this item?')) {
            postData("/api/DeleteFolder", {token: this.props.token}, {id: this.state.id})[0].then(() => {
                this.props.page("menu");
            });
        }
    }

    input(e) {
        this.setState({filter: e.target.value})
    }

    componentDidMount() {
        postData("/api/GetFolder", {token: this.props.token}, {id: this.props.folderid})[0].then((data) => this.setState({
            name: data.name,
            year: data.year,
            public: data.public,
            photos: data.photos,
            id: data.id
        }), console.log("failed to load folder"));
    }


    state = {name: undefined, public: 0, year: 0, photos: [], id: undefined};

    render() {
        return (<div>
                {
                    this.state.name === undefined && <p>Loading folder</p>
                }
                {this.state.name !== undefined &&
                    <div>
                        <h1>{this.state.name}</h1>
                        {this.props.admin && <p>Gepubliceerd in {this.state.year}, {this.state.public === "0" ? "niet publiek" : "publiek"}</p>}
                        {!this.props.admin && <p>Gepubliceerd in {this.state.year}</p>}
                        <button onClick={() => this.props.page("menu")}>Naar start</button>
                        {this.props.admin &&<button onClick={() => this.props.page("cam", this.state.id)}>Neem een photo (camera)</button>}
                        {this.props.admin &&<button onClick={() => this.props.page("upload", this.state.id)}>Upload foto's</button>}
                        {this.props.admin &&<button onClick={this.deleteFolder}>Verwijder map</button>}
                        {this.state.photos.length === 0 && <p>Geen foto's</p>}
                        {this.state.photos.length > 0 && <p>Afbeeldingen worden in volledige kwaliteit geladen, zonder compressie. Zo kunt u de foto’s eventueel afdrukken zonder kwaliteitsverlies.<br/> <strong>We raden wel een goede internetverbinding aan en vragen wat geduld.</strong></p>}
                        {this.state.photos.length > 0 && <ul id={"rig"}>
                            {this.state.photos.map((e) =>
                                <li id={e.id}>
                                    <a href={"/api/foto/" + e.location + "?token=" + this.props.token}
                                       download="De Paddestoeltjes image">
                                        <img loading="lazy" min-height={100}  
                                            className="rig-cell" src={"/api/foto/" + e.location + "?token=" + this.props.token}
                                            alt={"f"}/>
                                    </a>
                                    {this.props.admin && <button onClick={() => this.delete(e.id)}>Verwijder foto</button>}
                                </li>
                            )}
                        </ul>}
                    </div>
                }
            </div>
        );
    }


}
